import { render, staticRenderFns } from "./RecoverPassView.vue?vue&type=template&id=abf4b8c8&"
import script from "./RecoverPassView.vue?vue&type=script&lang=ts&"
export * from "./RecoverPassView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports